<template>
    <Login />
</template>
<script>
import Login from '@/components/Login.vue'
export default {
    name: 'login',
    components: {
        Login
    },
    data: () => ({
        //
    })
}
</script>
<style>
</style>